import { QuestionSource } from '../models'
import { isButtonQuestion, isUnlabeledButton, UNLABELED_BUTTON_TITLE } from '../viewModel'
import styles from './ChatbotAnalytics.module.scss'

const DASH = '—'
const DELETED_LABEL = 'Sohbet silinmiş'

export interface QuestionAnswerCellProps {
  question: string | null
  answer: string | null
  questionSource: QuestionSource | null
  /** Tamamlananlar satırında yoktur; verilmezse etiketsiz buton tespiti yapılmaz. */
  buttonIntent?: string | null
  conversationDeleted?: boolean
  /**
   * Sorular sekmesinin ayrı bir "Nasıl soruldu" sütunu vardır; orada rozet İKİNCİ kez basılmaz.
   * Geri Bildirimler ve Tamamlananlar'da rozet bu hücrededir.
   */
  showSourceBadge?: boolean
  expanded: boolean
  /** Ör. `feedback-row-0` → `feedback-row-0-question`, `-source`, `-answer`. */
  testIdPrefix: string
}

/**
 * Soru + (satır genişletilince) cevap hücresi — Geri Bildirimler ve Tamamlananlar sekmeleri ortak kullanır.
 * Buton etiketi tur metriğinden gelir: sohbet silinmiş olsa bile gösterilir.
 */
export default function QuestionAnswerCell({
  question,
  answer,
  questionSource,
  buttonIntent = null,
  conversationDeleted = false,
  showSourceBadge = true,
  expanded,
  testIdPrefix,
}: QuestionAnswerCellProps) {
  const sourceFields = { Question: question, QuestionSource: questionSource, ButtonIntent: buttonIntent }
  const clampClass = expanded ? styles.cellFull : styles.cellClamp
  const buttonQuestion = isButtonQuestion(sourceFields) && !!question
  const unlabeled = isUnlabeledButton(sourceFields)
  const questionText = (
    <span
      data-testid={`${testIdPrefix}-question-text`}
      className={unlabeled ? `${clampClass} ${styles.questionUnlabeled}` : clampClass}
      title={unlabeled ? UNLABELED_BUTTON_TITLE : question ?? undefined}
    >
      {question ?? DASH}
    </span>
  )
  const sourceBadge = buttonQuestion && showSourceBadge ? (
    <span className={`${styles.sourceBadge} ${styles.sourceBadgeButton}`} data-testid={`${testIdPrefix}-source`}>
      Buton
    </span>
  ) : null

  if (conversationDeleted) {
    return buttonQuestion ? (
      <div data-testid={`${testIdPrefix}-question`}>
        <span className={styles.questionLine}>
          <span className={styles.deletedBadge}>{DELETED_LABEL}</span>
          {sourceBadge}
          {questionText}
        </span>
      </div>
    ) : (
      <span className={styles.deletedBadge} data-testid={`${testIdPrefix}-question`}>
        {DELETED_LABEL}
      </span>
    )
  }

  return (
    <div data-testid={`${testIdPrefix}-question`}>
      <span className={styles.questionLine}>
        {sourceBadge}
        {questionText}
      </span>
      {expanded ? (
        <div className={styles.answerBlock} data-testid={`${testIdPrefix}-answer`}>
          <strong>Cevap</strong>
          <p>{answer ?? DASH}</p>
        </div>
      ) : null}
    </div>
  )
}
